import { render, staticRenderFns } from "./HealthCertificates.vue?vue&type=template&id=4d7c51e7"
import script from "./HealthCertificates.vue?vue&type=script&lang=js"
export * from "./HealthCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports